import { Radar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
} from 'chart.js';
import useStressStore from '../../../store/stressStores';


ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
);

const RaderChart = () => {
    const storeData: any = useStressStore();

    const stdSig = storeData.surveyInfoList.filter((d: any) => d.category_uid === "std-sig")[0]; // 기본형 총점
    const nationwideMin: any = Array.from(storeData.surveyInfoList.map((d: any) => d.score2_4)); // 전국
    const company_Min: any = Array.from(storeData.surveyInfoList.map((d: any) => d.average > 0 ? d.average : null)); // 사내 근로자
    const company_M_Min: any = Array.from(storeData.surveyInfoList.map((d: any) => d.averageM > 0 ? d.averageM : null)); // 사내 남성
    const company_F_Min: any = Array.from(storeData.surveyInfoList.map((d: any) => d.averageF > 0 ? d.averageF : null)); // 사내 여성
    const customerScores: any = Array.from(storeData.surveyInfoList.map((d: any) => d.score)); // 고객

    // if (company_Min.reduce((p: any, n: any, i: any) => p + n) < 1) {

    // }

    const data = {
        labels: Array.from(storeData.surveyInfoList.map((d: any) => d.category_name)),
        datasets: [
            {
                label: '전국 근로자',
                data: nationwideMin,
                backgroundColor: 'rgba(255, 137, 137, 0.2)',
                borderColor: 'rgba(255, 137, 137, 1)',
                borderWidth: 1,
            },
            {
                label: '사내 근로자',
                data: company_Min,
                backgroundColor: 'rgba(40, 163, 0, 0.2)',
                borderColor: 'rgba(40, 163, 0, 1)',
                borderWidth: 1,
            },
            {
                label: '사내 남성',
                data: company_M_Min,
                backgroundColor: 'rgba(137, 222, 255, 0.2)',
                borderColor: 'rgba(137, 222, 255, 1)',
                borderWidth: 1,
            },
            {
                label: '사내 여성',
                data: company_F_Min,
                backgroundColor: 'rgba(175, 136, 227, 0.2)',
                borderColor: 'rgba(175, 136, 227, 1)',
                borderWidth: 1,
            },
            {
                label: `${storeData.familyInfo.name} 님`,
                data: customerScores,
                backgroundColor: 'rgba(255, 197, 137, 0.2)',
                borderColor: 'rgba(255, 197, 137, 1)',
                borderWidth: 1,
            },
        ]
    }
    const option = {
        plugins: {
            legend: {

                labels: {
                    boxWidth: 70,
                    padding: 20
                }
            }
        }
    }

    return (
        <Radar data={data} options={option} />

    )
}


export default RaderChart;